export default "__VITE_ASSET__DqixmiZB__"